<template>
  <div>
    <b-container class="container-box">
      <b-row class="no-gutters">
        <b-col xl="7" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase mb-3">
            หมายเลขธุรกรรม : {{ bill.statementNo }}
          </h1>
        </b-col>
        <b-col
          xl="5"
          class="text-right d-flex justify-content-end align-items-center"
        >
          <b-button variant="link" class="px-1 py-0" @click="handleRoute">
            <u>ย้อนกลับ</u>
          </b-button>
        </b-col>
      </b-row>

      <div class="bg-white p-3">
        <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4">
          <b-col cols="7" cols-sm="6" cols-md="4" cols-lg="4">
            <p class="mb-0">
              <strong>วัน / เวลา ทำรายการ : </strong>
            </p></b-col
          >
          <b-col cols="5" cols-sm="6" cols-md="4" cols-lg="4">
            <p class="text-break mb-0">
              {{ new Date(bill.createdTime) | moment($formatDate) }}
              <span class="text-black-50">
                ({{ new Date(bill.createdTime) | moment($formatTime) }})</span
              >
            </p></b-col
          >
          <b-col cols="6" cols-sm="6" cols-md="4" cols-lg="4">
            <p class="mb-0"><strong>สถานะการชำระเงิน : </strong></p>
          </b-col>
          <b-col cols="6" cols-sm="6" cols-md="4" cols-lg="4">
            <p class="text-break mb-0">{{ bill.paymentStatusName }}</p>
          </b-col>
        </b-row>

        <b-row cols="1" cols-sm="2" cols-md="4">
          <b-col cols="6" cols-sm="6" cols-md="4" cols-lg="4">
            <p class="mb-0"><strong>ช่องทางการขาย : </strong></p>
          </b-col>
          <b-col cols="6" cols-sm="6" cols-md="4" cols-lg="4">
            <p class="mb-0 text-break">
              {{ bill.saleschannelName }}
            </p></b-col
          >
        </b-row>
      </div>

      <div class="summary-detail-section">
        <div class="mr-2 sum-section w-100 mt-2">
          <div
            class="header-purple d-flex justify-content-between align-items-center"
          >
            <p class="mb-0 text-black">
              <strong>สรุปรายการ</strong>
            </p>
          </div>
          <BillFinance :bill="bill" />
        </div>
        <div class="detail-section w-100 mt-2">
          <div
            class="header-purple d-flex justify-content-between align-items-center"
          >
            <p class="mb-0 text-black">
              <strong>รายละเอียดการยืนยัน</strong>
            </p>
            <div>
              <!-- <a class="pr-2 link-cancel" @click="closeModalConfirm">ยกเลิกรายการ</a> -->
              <a
                v-if="bill.paymentStatusName == 'รอการยืนยันธุรกรรม'"
                class="link-purple"
                v-b-modal.modalConfirm
                @click="setDefaultModal"
                >ยืนยันธุรกรรม</a
              >
            </div>
          </div>
          <div
            v-if="bill.paymentStatusName == 'ยืนยันธุรกรรม'"
            class="bg-white px-3 pt-3 pb-2 text-center"
          >
            <b-row>
              <b-col cols="6" class="text-left">
                <p><strong>วันที่ยืนยัน</strong></p>
              </b-col>
              <b-col class="text-left">
                <p class="mb-0 text-break">
                  {{
                    new Date(dataConfirm.acceptedTime) | moment($formatDateTime)
                  }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="text-left">
                <p><strong>จำนวนรายการที่ยืนยัน</strong></p>
              </b-col>
              <b-col class="text-left">
                <p class="mb-0 text-break">
                  {{ dataConfirm.numberConfirm }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="text-left">
                <p><strong>จำนวนเงินที่ได้รับจริง</strong></p>
              </b-col>
              <b-col class="text-left">
                <p class="mb-0 text-break">
                  {{ dataConfirm.realIncome }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="text-left">
                <p><strong>ผู้ยืนยัน</strong></p>
              </b-col>
              <b-col class="text-left">
                <p class="mb-0 text-break">
                  {{ dataConfirm.confirmer }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="text-left">
                <p><strong>ข้อความเพิ่มเติม</strong></p>
              </b-col>
              <b-col class="text-left">
                <p class="mb-0 text-break">
                  {{ dataConfirm.message }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="text-left">
                <p class="mb-0">
                  <strong>หลักฐานธุรกรรม (pdf, png, jpg)</strong>
                </p>
              </b-col>
              <b-col>
                <div class="list-img-section flex-wrap d-flex flex-row">
                  <div class="panel-wrap-bg-file-img">
                    <div
                      class="panel-bg-file-img"
                      v-bind:style="{
                        backgroundImage: 'url(' + dataConfirm.filePath + ')',
                      }"
                    ></div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-else class="bg-white px-3 pt-3 pb-2 text-center">
            <p class="mb-2">ไม่มีข้อมูล</p>
            <a
              class="link-purple"
              v-b-modal.modalConfirm
              @click="setDefaultModal"
              >ยืนยันธุรกรรม</a
            >
          </div>
        </div>
      </div>

      <b-modal
        size="lg"
        id="modalConfirm"
        ref="modalConfirm"
        centered
        hide-footer
        content-class="content-modal-class"
        header-class="header-modal-class"
      >
        <template #modal-header>
          <div class="d-flex justify-content-between align-items-center w-100">
            <span class="title-modal">รายละเอียดการยืนยัน</span>
            <p class="mb-0">
              อัพเดทล่าสุด :
              {{ new Date(bill.updatedTime) | moment($formatDateTime) }}
            </p>
          </div>
        </template>

        <form v-on:submit.prevent="submitDetail">
          <div class="px-1 input-date-container">
            <label class="font-weight-bold text-label-date">
              วันที่ยืนยัน
              <span class="text-danger">*</span>
            </label>
            <div
              :class="[
                'input-container',
                { error: $v.formConfirm.acceptedTime.$error },
              ]"
            >
              <datetime
                :input-style="styleDatetime"
                v-model="formConfirm.acceptedTime"
                placeholder="วว / ดด / ปป"
                ref="acceptedTime"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.acceptedTime.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
            <div v-if="$v.formConfirm.acceptedTime.$error">
              <span class="text-error">กรุณาเลือกวันที่</span>
            </div>
          </div>

          <div class="d-flex flex-row w-100">
            <div class="w-100 px-1 pb-0">
              <InputText
                :value="formConfirm.numberConfirm"
                textFloat="จำนวนรายการที่ยืนยัน"
                placeholder="0"
                type="number"
                :disabled="true"
                name="numberConfirm"
                :isValidate="$v.formConfirm.numberConfirm.$error"
                isRequired
                :v="$v.formConfirm.numberConfirm"
                @onDataChange="(val) => (formConfirm.numberConfirm = val)"
              />
            </div>
            <div class="w-100 px-1 pb-0">
              <InputText
                :value="formConfirm.realIncome"
                textFloat="จำนวนเงินที่ได้รับจริง"
                placeholder="฿0.00"
                type="number"
                name="realIncome"
                :isValidate="$v.formConfirm.realIncome.$error"
                isRequired
                :v="$v.formConfirm.realIncome"
                :disabled="false"
                @onDataChange="(val) => (formConfirm.realIncome = val)"
              />
            </div>
          </div>
          <InputText
            :value="formConfirm.confirmer"
            textFloat="ผู้ยืนยัน"
            placeholder="ชื่อ-นามสกุล"
            type="text"
            name="name"
            :isValidate="$v.formConfirm.confirmer.$error"
            isRequired
            :v="$v.formConfirm.confirmer"
            @onDataChange="(val) => (formConfirm.confirmer = val)"
            class="px-1"
          />
          <div class="px-1">
            <UploadFile
              textFloat="หลักฐานธุรกรรม"
              text="อัพโหลดไฟล์ประเภท png. jpg. -okf 1000x1000 ไม่เกิน 10MB"
              format="image"
              :fileName="formConfirm.imageName"
              v-model="formConfirm.filePath"
              placeholder="อัพโหลดไฟล์แนบ"
              v-on:onFileChange="(file) => onImageChange(file)"
              v-on:delete="deleteImage"
            />
          </div>
          <InputTextArea
            :value="formConfirm.message"
            textFloat="ข้อความเพิ่มเติม"
            type="text"
            class="mt-0 px-1"
            placeholder="ใส่ข้อความ"
            rows="3"
            name="messageModal"
            @onDataChange="(val) => (formConfirm.message = val)"
          />

          <div class="mt-2 my-1 px-1">
            <b-container class="p-0">
              <b-row class="no-gutters">
                <b-col md="6" class="d-flex">
                  <b-button class="btn-main-2" @click="closeModalConfirm"
                    >ยกเลิก</b-button
                  >
                </b-col>
                <b-col
                  md="6"
                  class="d-flex justify-content-md-end mt-3 mt-md-0"
                >
                  <b-button type="submit" class="btn-main">บันทึก</b-button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </form>
      </b-modal>
      <div
        class="mt-2 header-purple d-flex justify-content-between align-items-center"
      >
        <p class="mb-0 text-black">
          <strong>รายการคำสั่งซื้อ</strong>
        </p>
        <a @click="exportData()" class="link-purple">นำออกรายการ</a>
      </div>
      <div class="bg-white p-3">
        <b-table
          :busy="isBusy"
          id="table-list"
          responsive
          :items="items"
          :fields="fields"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:cell(createdTime)="data">
            <p class="text-break mb-0">
              {{ new Date(data.item.createdTime) | moment($formatDate) }}
              <span class="text-black-50">
                ({{
                  new Date(data.item.createdTime) | moment($formatTime)
                }})</span
              >
            </p>
          </template>
        </b-table>
        <b-row
          class="no-gutters px-3 px-sm-0 d-flex justify-content-end w-100"
          v-if="!isBusy"
        >
          <b-col class="form-inline justify-content-end">
            <div class="d-sm-flex mr-3">
              <b-pagination
                v-model="filter.page"
                :total-rows="rows"
                :per-page="filter.take"
                class="m-md-0 page-item"
                :hide-goto-end-buttons="true"
                aria-controls="table-list"
                @change="pagination"
              ></b-pagination>
            </div>
            <b-form-select
              class="mr-sm-1 select-page"
              v-model="filter.take"
              @change="handleChangeTake"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <ModalAlert
      ref="modalAlert"
      :text="messageAlert"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="messageError" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import UploadFile from "@/components/inputs/UploadFile";
import { required } from "vuelidate/lib/validators";
import BillFinance from "./components/bill/BillPanel.vue";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  components: {
    InputText,
    InputTextArea,
    UploadFile,
    BillFinance,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      filter: {
        StatamentId: this.$route.params.id,
        take: 10,
        page: 1,
      },
      bill: {
        orderCount: 0,
        subtotal: 0,
        shippingCost: 0,
        totalDiscount: 0,
        platformDiscount: 0,
        shopDiscount: 0,
        realShippingCost: 0,
        platformGP: 0,
        paymentFee: 0,
        paymentVATFee: 0,
        transferFee: 0,
        serviceCost: 0,
      },
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      isBusy: false,
      formConfirm: {
        acceptedTime: "",
        numberConfirm: "",
        realIncome: "",
        confirmer: "",
        message: "",
        filePath: "",
        imageName: "",
      },
      dataConfirm: {
        id: "",
        paymentStatusId: "",
        numberConfirm: "",
        filePath: "",
        acceptedTime: "",
        confirmer: "",
        message: "",
        realIncome: "",
      },
      fields: [
        {
          key: "invoiceNo",
          label: "หมายเลขคำสั่งซื้อ",
          class: "w-100px text-nowrap",
        },
        {
          key: "receiptNo",
          label: "ใบกำกับอย่างย่อ",
          class: "w-100px text-nowrap",
        },
        {
          key: "createdTime",
          label: "วันที่คำสั่งซื้อ",
          class: "w-100px text-nowrap",
        },
        {
          key: "orderStatusName",
          label: "สถานะคำสั่งซื้อ",
          class: "w-100px text-nowrap",
        },
      ],
      items: [],
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      imageUrl: null,
      isLoadingImage: false,
      messageAlert: "",
      messageError: "",
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  validations() {
    return {
      formConfirm: {
        acceptedTime: { required },
        numberConfirm: { required },
        realIncome: { required },
        confirmer: { required },
        // message: { required },
        // filePath: { required },
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    handleRoute() {
      if (this.hasHistory()) this.$router.back();
      else
        this.$router.push({
          path: `/order?brandID=${this.$route.query.brandID}`,
        });
    },
    getDetail() {
      this.isBusy = true;
      this.axios
        .post(`${this.$baseUrl}/statement/detail`, this.filter)
        .then((response) => {
          if (response.result === 1) {
            this.isBusy = false;
            this.bill = response.detail.statement;
            this.formConfirm.numberConfirm =
              response.detail.statement.orderCount;
            this.items = response.detail.statementOrder;
            if (response.detail.statement.paymentStatusId === 2) {
              this.dataConfirm.id = response.detail.statement.id;
              this.dataConfirm.paymentStatusId =
                response.detail.statement.paymentStatusId;
              this.dataConfirm.filePath = response.detail.statement.filePath;
              this.dataConfirm.numberConfirm =
                response.detail.statement.orderCount;
              this.dataConfirm.acceptedTime =
                response.detail.statement.acceptedTime;
              this.dataConfirm.confirmer = response.detail.statement.confirmer;
              this.dataConfirm.message = response.detail.statement.message;
              this.dataConfirm.realIncome =
                response.detail.statement.realIncome;
            }
          }
        });
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getDetail();
    },
    pagination(page) {
      this.filter.page = page;
      this.getDetail();
    },
    onImageChange: async function(file) {
      this.isLoadingImage = true;
      this.formConfirm.imageName = file.name;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        this.imageUrl = await this.saveImagetoDb(reader.result);
        this.isLoadingImage = false;

        this.formConfirm.filePath = this.imageUrl;
      };
    },
    saveImagetoDb: async function(img) {
      this.$refs.modalLoading.show();
      var imgData = {
        base64: img,
      };
      return new Promise((resolve, reject) => {
        this.axios.post(`${this.$baseUrl}/image/save`, imgData).then((data) => {
          if (data.result == 1) {
            this.$refs.modalLoading.hide();
            resolve(data.detail.url);
          } else {
            reject(data);
          }
        });
      });
    },
    submitDetail() {
      this.$refs.modalLoading.show();
      this.$v.formConfirm.$touch();
      if (this.$v.formConfirm.$error) {
        return;
      }
      
      this.$v.formConfirm.$reset();
      this.dataConfirm.id = this.bill.id;
      this.dataConfirm.paymentStatusId = this.bill.paymentStatusId;
      this.dataConfirm.filePath = this.formConfirm.filePath;
      this.dataConfirm.acceptedTime = this.formConfirm.acceptedTime;
      this.dataConfirm.confirmer = this.formConfirm.confirmer;
      this.dataConfirm.message = this.formConfirm.message;
      this.dataConfirm.realIncome = this.formConfirm.realIncome;
      // console.log('dataConfirm', this.dataConfirm);
      this.axios
        .post(`${this.$baseUrl}/statement/ApproveStatement`, this.dataConfirm)
        .then((response) => {
          this.$refs.modalLoading.hide();
          if (response.result == 1) {
            this.messageAlert = response.message;
            this.$refs.modalAlert.show();
            setTimeout(() => {
              this.$refs.modalAlert.hide();
            }, 3000);
            this.clear();
          } else {
            this.messageError = response.message;
            this.$refs.modalAlertError.show();
          }
        });
    },
    hadleModalAlertClose: function() {
      this.$router.push({ path: `/finance` });
    },
    closeModalConfirm() {
      this.$refs.modalConfirm.hide();
    },
    clear() {
      this.formConfirm = {
        acceptedTime: "",
        numberConfirm: "",
        realIncome: "",
        confirmer: "",
        message: "",
        filePath: "",
        imageName: "",
      };
    },
    deleteImage() {
      this.formConfirm.imageName = "";
      this.formConfirm.filePath = "";
    },
    async exportData() {
      this.$refs.modalLoading.show();
      this.axios
        .get(
          `${this.$baseUrl}/statement/ExportStatementOrder/${this.filter.StatamentId}`,
          { responseType: "blob" }
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response]));
          var fileLink = document.createElement("a");
          var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `document-` + dateExcel + `.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
    setDefaultModal() {
      this.formConfirm.acceptedTime = this.$moment.utc().format();
      this.formConfirm.realIncome =
        this.bill.subtotal +
        this.bill.shippingCost -
        this.bill.totalDiscount +
        this.bill.platformDiscount -
        (this.bill.realShippingCost +
          this.bill.platformGP +
          this.bill.paymentFee +
          this.bill.paymentVATFee +
          this.bill.transferFee +
          this.bill.serviceCost);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #092d53;
}
a:hover {
  color: #b41bb4;
  cursor: pointer;
  text-decoration: underline;
}
.link-purple {
  color: #b41bb4;
  text-decoration: underline;
}
.link-cancel {
  color: #8a93a2;
  text-decoration: underline;
}
.text-purple {
  color: #b41bb4;
}
.text-grey {
  color: #8a93a2;
}
.sum-section {
  width: 40%;
}
.detail-section {
  width: 60%;
  background-color: white;
}
.text-id-purchase {
  text-decoration: underline;
  color: rgb(81, 112, 199);
}
/deep/ .header-modal-class {
  background: #5b57a547;
}
/deep/ .content-modal-class {
  border: 0;
}
.title-modal {
  font-weight: bold;
  color: black;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}
.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.text-label-date {
  color: #404040;
  margin-bottom: 2px;
}
.input-date-container {
  margin-bottom: 15px;
}
.list-img-section {
  width: 100%;
}
.panel-wrap-bg-file-img {
  width: 100px;
  padding-right: 10px;
  padding-bottom: 10px;
}
.panel-bg-file-img {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  padding-bottom: 100%;
  border: 2px solid #979797;
  width: 100%;
}
// style table
/deep/ table td,
.table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
/deep/ .table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
  border-bottom: 1px solid #ccc;
}
.summary-detail-section {
  display: flex;
  flex-direction: row;
}
@media (max-width: 767.98px) {
  .summary-detail-section {
    flex-direction: column;
  }
}
</style>
